import { apiGet, apiPost } from "../../utils"

export function getNewsAPI() {
    return apiGet('/api/getNews')
}

export function addNewsAPI(data) {
    return apiPost('/api/addNews', data)
}
